import React from 'react';
import {
  FormField,
  DatePicker,
  Button,
  Select
} from '../../../ui';
import './style.css';
import { useAppDispatch, useAppSelector } from "../../../redux/hooks";
import {
  setTripsDateRageFilter,
  setTripsPaymentState,
  setTripServiceProvider,
  selectTrips,
  selectCustomer
} from "../../../redux/slices/customer-slice";
import { FilterByDateRange } from '../../../redux/slices/types';
import { FilterTripHistoryServiceProviderTypes, FilterTripServiceProviderTypes, TripServiceProvider } from '../trip-history/types';
import { FilterPaymentState, FilterTripHistoryPaymentState, TripPaymentState } from '../../../utils/trip-invoice-utils';

export default function TripHistoryDataFilter() {
  const dispatch = useAppDispatch();
  const trips = useAppSelector(selectTrips());
  const customer = useAppSelector(selectCustomer());

  function setDateRange(dateRange: FilterByDateRange) {
    dispatch(setTripsDateRageFilter(dateRange));
  }

  function setPaymentState(paymentState: FilterTripHistoryPaymentState) {
    dispatch(setTripsPaymentState(paymentState));
  }

  function setServiceProvider(serviceProvider: FilterTripHistoryServiceProviderTypes) {
    dispatch(setTripServiceProvider(serviceProvider));
  }

  function handleOnDateRangeChange(e) {
    if (e.includes('bis')) {
      const SPLIT_FLAG = ' bis ';
      const dates = e.split(SPLIT_FLAG);
      setDateRange({
        start: dates[0],
        stop: dates[1],
      })
    }
  }

  function handleResetFilters() {
    setDateRange(undefined);
    setPaymentState('ALL')
    setServiceProvider('ALL')
  }

  return (
    <>
      <div data-testid="tripsFilter" key="tripsFilter" className="filter-group">
        <FormField
          labelText="Select Date Range"
          type="input"
          testId='testSelectDateRange'
        >
          <div style={{ margin: 'auto' }}>
            <DatePicker
              testId='testDatePicker'
              key="tripsDataRangeSelect"
              mode='range'
              value={trips.filter?.dateRange ? `${trips.filter.dateRange.start} bis ${trips.filter.dateRange.stop}` : undefined}
              onChange={handleOnDateRangeChange}
            />
          </div>
        </FormField>
        <FormField
          labelText="Select Service Provider"
          type="input"
          testId='testSelectMSP'
        >
          <Select onChange={(e) => setServiceProvider(e.target.value as FilterTripServiceProviderTypes)} value={trips?.filter?.serviceProvider || 'ALL'}>
            <Select.Item value={'ALL'}>All</Select.Item>
            {Object.keys(TripServiceProvider).map(key => <Select.Item key={key} value={key}>{TripServiceProvider[key]}</Select.Item>)}
          </Select>
        </FormField >
        <FormField
          labelText="Select Payment State"
          type="input"
          testId='testSelectPaymentState'
        >
          <Select onChange={(e) => setPaymentState(e.target.value as FilterPaymentState)} value={trips?.filter?.paymentState || 'ALL'}>
            <Select.Item value={'ALL'}>All</Select.Item>
            {Object.keys(TripPaymentState).map(key => <Select.Item key={key} value={key}>{TripPaymentState[key]}</Select.Item>)}
          </Select>
        </FormField >
        <FormField
          labelText="Action"
          type="input"
        >
          <Button
            onClick={handleResetFilters}
            key="resetTripFilters"
            testId='testResetFiltersBtn'
          >
            Reset filters
          </Button>
        </FormField >
      </div >
      <span data-testid='testOpenPayments'>
        <b style={{ marginRight: '2px' }}>Open Payments:</b>
        <span>
          {customer.customer?.hasOpenPayments ? 'YES' : 'NO'}
        </span>
        <div>
          {
            customer.customer?.hasOpenPayments &&
            <>
              <span><b style={{ marginRight: '2px' }}>Number of Open Payments:</b> {customer.customer.openPaymentsDetails.count}</span><br></br>
              <span><b style={{ marginRight: '2px' }}>Total Unpaid Amount:</b> {customer.customer.openPaymentsDetails.totalAmount} €</span>
            </>
          }
        </div>
      </span >
    </>
  );
}
